"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectWithUs = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var index_1 = require("../../../index");
function ConnectWithUs() {
    return (react_1.default.createElement(index_1.SettingContainer, null,
        react_1.default.createElement(index_1.DefaultTitle, null, "\u8054\u7CFB\u6211\u4EEC"),
        react_1.default.createElement("span", null, "Schemeandpayment")));
}
exports.ConnectWithUs = ConnectWithUs;
//# sourceMappingURL=ConnectWithUs.js.map